import { Component, inject } from '@angular/core';
import { LoaderService } from '../../../services/loader-service';

@Component({
  selector: 'app-system-loader',
  imports: [],
  templateUrl: './system-loader.html',
  styleUrl: './system-loader.scss',
})
export class SystemLoader {
  public loader = inject(LoaderService);
}
